import { Box, Button, ButtonGroup, Stack } from "@mui/material";
import { TSearchableItem } from "components/SearchableList";
import { forwardRef, useContext, useEffect, useImperativeHandle, useState } from "react";
import { useFormContext } from "react-hook-form";

import { MemberFormContext } from "../..";

const ExerciseReadinessTab = forwardRef(
  (
    props: {
      exerciseReadinessOptionsSets: TSearchableItem[];
    },
    ref
  ) => {
    const { exerciseReadinessOptionsSets } = props;
    const memberFormContext = useContext(MemberFormContext);
    const formContext = useFormContext();
    const { setValue, getValues } = formContext;
    const [formExerciseReadiness, setFormExerciseReadiness] = useState<number[]>();
    const [formExerciseReadinessAnswerNo, setFormExerciseReadinessAnswerNo] = useState<number[]>(
      []
    );

    useEffect(() => {
      const exerciseReadiness = (getValues("exercise_readiness") as any[]) || [];
      const includedExerciseReadiness = exerciseReadiness.map((e) => e.health_info_id);
      setFormExerciseReadiness(includedExerciseReadiness);
      //Only set No buttons when there are ones selected (loading data previously entered)
      let idToSetNo = [];
      if (!memberFormContext.isEditMode) {
        if (includedExerciseReadiness.length > 0) {
          exerciseReadinessOptionsSets.forEach((e) => {
            if (!includedExerciseReadiness.includes(e.value)) {
              idToSetNo.push(e.value);
            }
          });
        }
      } else {
        exerciseReadinessOptionsSets.forEach((e) => {
          if (!includedExerciseReadiness.includes(e.value)) {
            idToSetNo.push(e.value);
          }
        });
      }
      setFormExerciseReadinessAnswerNo(idToSetNo);
    }, []);

    useImperativeHandle(ref, () => ({
      validate() {
        return formExerciseReadiness.length + formExerciseReadinessAnswerNo.length ===
          exerciseReadinessOptionsSets.length
          ? formExerciseReadiness.length || true // || true is added to account for when all questions are answered no
          : 0;
      },
    }));

    //#region event handlers
    const handleUpdateExerciseReadiness = (v: number, isAddNotRemove: boolean) => {
      let exerciseReadiness: any[] = formExerciseReadiness;
      const indexInArray = exerciseReadiness.findIndex((f) => f === v);
      if (isAddNotRemove) {
        if (indexInArray === -1) exerciseReadiness.push(v);
      } else {
        if (indexInArray !== -1) exerciseReadiness.splice(indexInArray, 1);
      }
      setFormExerciseReadiness([...exerciseReadiness]);
      setValue(
        "exercise_readiness",
        exerciseReadiness.map((e) => ({
          health_info_id: e,
        }))
      );

      //#region flagging the entry as No
      let exerciseReadinessAnswerNo: any[] = formExerciseReadinessAnswerNo;
      const indexInArrayAnswerNo = exerciseReadinessAnswerNo.findIndex((f) => f === v);
      if (!isAddNotRemove) {
        if (indexInArrayAnswerNo === -1) exerciseReadinessAnswerNo.push(v);
      } else {
        if (indexInArrayAnswerNo !== -1) exerciseReadinessAnswerNo.splice(indexInArrayAnswerNo, 1);
      }
      setFormExerciseReadinessAnswerNo([...exerciseReadinessAnswerNo]);
      //#endregion flagging the entry as No
    };
    //#endregion event handlers

    return (
      <Stack height={"100%"}>
        {exerciseReadinessOptionsSets.map((e, index) => (
          <Box className="rowQuestionBox" key={`memberExerciseReadinessEntry_${index}`}>
            <Stack direction={"row"} alignItems="center">
              <Box flexGrow={1}>{e.label}</Box>
              <Box width={"130px"}>
                <ButtonGroup className="button-group">
                  <Button
                    className={`${
                      formExerciseReadinessAnswerNo?.includes(+e.value) ? `active` : ``
                    }`}
                    onClick={() => handleUpdateExerciseReadiness(e.value as number, false)}
                    type="button"
                  >
                    No
                  </Button>
                  <Button
                    className={`${formExerciseReadiness?.includes(+e.value) ? `active green` : ``}`}
                    onClick={() => handleUpdateExerciseReadiness(e.value as number, true)}
                    type="button"
                  >
                    Yes
                  </Button>
                </ButtonGroup>
              </Box>
            </Stack>
          </Box>
        ))}
      </Stack>
    );
  }
);

export default ExerciseReadinessTab;
